<template>
  <aside class="widget">
    <h4>Admin Control</h4>
    <router-link to="/report-ve-awards">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Review: VE Employee Awards <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/report-innovation-awards">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Review: Innovation Awards <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/report-archived">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Review: Archived Awards <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/report-dashboard">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Review: Dashboard <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/reminder">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Nomination: Reminder <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/eereminder">
      <h5 class="mb-2"><i class="fas fa-clipboard-list fa-fw"></i> Equity: Reminder <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/report-idea-challenges">
      <h5><i class="fas fa-clipboard-list fa-fw"></i> Reports: Idea Challenges <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/report-make-your-mark">
      <h5><i class="fas fa-clipboard-list fa-fw"></i> Reports: Innovation Always On Site <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
    <router-link to="/abuse-reports">
      <h5><i class="fas fa-clipboard-list fa-fw"></i> All Abuse reports <i class="fas fa-angle-right fa-xs"></i></h5>
    </router-link>
  </aside>
</template>

<script>

export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminControls.vue